<div class="container-fluid" style="padding:0">
    <div class="row">
        <div class="col-lg-2">
            <app-navbar></app-navbar>
        </div>  
        <div class="col-lg-10">
            <br><br>
            <div class="row">
                <div class="col-lg-8">
                    <h3 class="titulo">Proveedores</h3>
                </div>

                <div class="col-lg-3">
                    <button class="boton fondoAmarillo blanco bold" (click)="openModal(agregarModal)">Agregar Proveedor</button>
                </div>
            </div>

            <div class="row">
                <div class="col-lg-11">
                    <br>
                    <table class="table table-striped center">
                        <thead>
                            <tr>
                                <td>Fecha</td>
                                <td>Nombre</td>
                                <td>RFC</td>
                                <td>Dirección</td>
                                <td>Contacto</td>
                                <td>Datos de Contacto</td>
                                <td>Acciones</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let proveedor of proveedores">
                                <td>{{proveedor.fecha}}</td>
                                <td>{{proveedor.nombre_razon_social}}</td>
                                <td>{{proveedor.rfc}}</td>
                                <td>{{proveedor.direccion}}, {{proveedor.colonia}}
                                    {{proveedor.cp}}, {{proveedor.municipio.nombre}}, 
                                    {{proveedor.municipio.estado}}, 
                                </td>

                                <td>{{proveedor.contacto}} <br></td>
                                <td>
                                    {{proveedor.telefono}}<br>
                                    {{proveedor.celular}}<br>
                                    {{proveedor.email}}<br>
                                </td>
                                
                                
                                <td>
                                    <svg (click)="editar(proveedor.id)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pencil-fill" viewBox="0 0 16 16">
                                        <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z"/>
                                    </svg>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #agregarModal let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h2>Agregar Proveedor</h2>
      <button type="button" class="close" (click)="dismissAll()" data-dismiss="modal">&times;</button>
    </div>

    <div class="modal-body">
        <span class="bold">Nombre o razón social:</span><br>
        <input type="text" class="form-control" placeholder="Nombre" [(ngModel)]="formulario.nombre"><br>
        <span class="bold">RFC</span><br>
        <input type="text" class="form-control" placeholder="RFC" [(ngModel)]="formulario.rfc"><br>
        <span class="bold">Calle y número:</span><br>
        <input type="text" class="form-control" placeholder="Calle y número" [(ngModel)]="formulario.direccion"><br>
        <span class="bold">Colonia:</span><br>
        <input type="text" class="form-control" placeholder="Colonia" [(ngModel)]="formulario.colonia"><br>
        <span class="bold">Código Postal:</span><br>
        <input type="text" class="form-control" placeholder="Código Postal" [(ngModel)]="formulario.cp"><br>
        <span class="bold">Estado:</span><br>
        <select class="form-control" [(ngModel)]="formulario.estado" (change)="getMunicipios();">
            <option value="">Seleccione opción</option>
            <option  *ngFor="let estado of estados" [value]="estado.id">{{estado.nombre}}</option>
        </select><br>

        <span class="bold">Municipio:</span><br>
        <select class="form-control" [(ngModel)]="formulario.municipio">
            <option value="">Seleccione opción</option>
            <option  *ngFor="let municipio of municipios" [value]="municipio.id">{{municipio.nombre}}</option>
        </select><br>

        <span class="bold">Contacto</span><br>
        <input type="text" class="form-control" placeholder="Nombre del Contacto" [(ngModel)]="formulario.contacto"><br>

        <span class="bold">Teléfono</span><br>
        <input type="text" class="form-control" placeholder="Teléfono" [(ngModel)]="formulario.telefono"><br>

        <span class="bold">Celular</span><br>
        <input type="text" class="form-control" placeholder="Celular" [(ngModel)]="formulario.celular"><br>

        <span class="bold">Correo electrónico</span><br>
        <input type="email" class="form-control" placeholder="Correo electrónico" [(ngModel)]="formulario.email"><br>
       
    </div>

    <div class="modal-footer">
        <button class="btn btn-primary" (click)="agregar()">Agregar Proveedor</button>
    </div>
</ng-template>


<div id="clickEditar" (click)="openModal(editarModal)"></div>
<ng-template #editarModal let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h2>Editar Pago</h2>
      <button type="button" class="close" (click)="dismissAll()" data-dismiss="modal">&times;</button>
    </div>

    <div class="modal-body">
        <span class="bold">Nombre o razón social:</span><br>
        <input type="text" class="form-control" placeholder="Nombre" [(ngModel)]="formularioEdit.nombre"><br>
        <span class="bold">RFC</span><br>
        <input type="text" class="form-control" placeholder="RFC" [(ngModel)]="formularioEdit.rfc"><br>
        <span class="bold">Calle y número:</span><br>
        <input type="text" class="form-control" placeholder="Calle y número" [(ngModel)]="formularioEdit.direccion"><br>
        <span class="bold">Colonia:</span><br>
        <input type="text" class="form-control" placeholder="Colonia" [(ngModel)]="formularioEdit.colonia"><br>
        <span class="bold">Código Postal:</span><br>
        <input type="text" class="form-control" placeholder="Código Postal" [(ngModel)]="formularioEdit.cp"><br>
        <span class="bold">Estado:</span><br>
        <select class="form-control" [(ngModel)]="formularioEdit.estado" (change)="getMunicipios();">
            <option value="">Seleccione opción</option>
            <option  *ngFor="let estadoE of estados" [value]="estadoE.id">{{estadoE.nombre}}</option>
        </select><br>

        <span class="bold">Municipio:</span><br>
        <select class="form-control" [(ngModel)]="formularioEdit.municipio">
            <option value="">Seleccione opción</option>
            <option  *ngFor="let municipioE of municipiosE" [value]="municipioE.id">{{municipioE.nombre}}</option>
        </select><br>

        <span class="bold">Contacto</span><br>
        <input type="text" class="form-control" placeholder="Nombre del Contacto" [(ngModel)]="formularioEdit.contacto"><br>

        <span class="bold">Teléfono</span><br>
        <input type="text" class="form-control" placeholder="Teléfono" [(ngModel)]="formularioEdit.telefono"><br>

        <span class="bold">Celular</span><br>
        <input type="text" class="form-control" placeholder="Celular" [(ngModel)]="formularioEdit.celular"><br>

        <span class="bold">Correo electrónico</span><br>
        <input type="email" class="form-control" placeholder="Correo electrónico" [(ngModel)]="formularioEdit.email"><br>
    </div>

    <div class="modal-footer">
        <button class="btn btn-primary" (click)="actualizar(proveedorId)">Actualizar Proveedor</button>
    </div>
</ng-template>